import { graphql } from "~/gql";
export const GET_TOP_DOWN_RATES = graphql(/* GraphQL */ `
  query GetTopDownRates($filter: RateFilter!) {
    getTopDownRates(filter: $filter) {
      feeEarnerLevelId
      order
      rates {
        id
        type
        isLevelRate
        amount
        description
        feeEarner {
          id
        }
        feeEarnerLevel {
          id
          description
          order
        }
        organisationalUnit {
          id
        }
        client {
          id
        }
      }
    }
  }
`);
